// アコーディオンパネル
    const setUpAccordion = () => {
      const details = document.querySelectorAll(".js-details");
      const isRunning = "running"; // アニメーション実行中のときに付与する予定のカスタムデータ属性の値
      const isOpend = "is-opened"; // アイコン操作用のクラス名
  
      details.forEach((element) => {
        const summary = element.querySelector(".js-summary");
        const content = element.querySelector(".js-content");
        const summaryText = summary.querySelector('p > span'); // 質問文以外のテキスト要素を指定
  
        // 初期状態のテキスト色を保存 (必要に応じて)
        if (summaryText && !summaryText.dataset.originalColor) {
          summaryText.dataset.originalColor = window.getComputedStyle(summaryText).color;
        }
  
        summary.addEventListener("click", (event) => {
          event.preventDefault();
          if (element.dataset.animStatus === isRunning) {
            return;
          }
          if (element.open) {
            element.classList.toggle(isOpend);
            const closingAnim = content.animate(
              closingAnimKeyframes(content),
              animTiming
            );
  
            element.dataset.animStatus = isRunning;
            closingAnim.onfinish = () => {
              element.removeAttribute("open");
              element.dataset.animStatus = "";
              if (summaryText) {
                summaryText.style.color = summaryText.dataset.originalColor; // 元の色に戻す
              }
            };
          } else {
            element.setAttribute("open", "true");
            element.classList.toggle(isOpend);
  
            const openingAnim = content.animate(
              openingAnimKeyframes(content),
              animTiming
            );
            element.dataset.animStatus = isRunning;
            openingAnim.onfinish = () => {
              element.dataset.animStatus = "";
              if (summaryText) {
                summaryText.style.color = 'black'; // 強制的に黒にする
              }
            };
          }
        });
      });
    };
  
    /* アニメーションの時間とイージング */
    const animTiming = {
      duration: 400,
      easing: "ease-out",
    };
  
    /*　アコーディオンを閉じるときのキーフレーム　*/
    const closingAnimKeyframes = (content) => [
      {
        height: content.offsetHeight + "px",
        opacity: 1,
      },
      {
        height: 0,
        opacity: 0,
      },
    ];
  
    /* アコーディオンを開くときのキーフレーム */
    const openingAnimKeyframes = (content) => [
      {
        height: 0,
        opacity: 0,
      },
      {
        height: content.offsetHeight + "px",
        opacity: 1,
      },
    ];
  
   
    // 当月の日にちを取得して15日より前だったら画像を差し替える
    const stockAvailable = () => {
      const targetElm = document.querySelectorAll(".js-available");
      if (targetElm.length > 0) {
        targetElm.forEach((e) => {
          const targetImg = e.querySelector(".js-available__this-month");
          // 現在の日付を取得
          const currentDate = new Date();
          // 日付の日部分を取得
          const dayOfMonth = currentDate.getDate();
          if (dayOfMonth <= 15) {
            // 月初から15日までの処理
            let src = targetImg.querySelector("img").getAttribute("src");
            src = src.replace(
              "available_this_month.png",
              "available_this_month_v2.png"
            );
            targetImg.querySelector("img").setAttribute("src", src);
          }
        });
      }
    };
      // 最初から表示するためのコードを追加
      const targetElements = document.querySelectorAll(".will-anm");
      targetElements.forEach(element => {
        element.classList.add("is-anm-show");
      });
  
  window.addEventListener("DOMContentLoaded", function () {
      stockAvailable();
      setUpAccordion();
  
      // 最初から表示するためのコードを追加
      const targetElements = document.querySelectorAll(".will-anm");
      targetElements.forEach(element => {
          element.classList.add("is-anm-show");
      });
  });
  
;

    /**
     * ページロード時に実行(data-* 属性を読み込んでスタイルを充てる)
     * @param {HTMLElement} targetElm ターゲットとなるelement
     * @param {string} textElm コピーターゲットのdom要素を指定
     * @param {string} targetClass ターゲットとなるelementのclass名
     */
    function setupCoupon(targetElm, textElm, targetClass) {
      var newStyle = document.createElement("style");
      document.getElementsByTagName("head")[0].appendChild(newStyle);
      let addStyles = [];
      const obj = { ...targetElm.dataset };
      
      // datasetで取得したdata属性全てをループで回す
      Object.keys(obj).forEach(function (key) {
        if (key == "code") {
          targetElm.querySelector(textElm).textContent = obj[key];
        } else if (key == "codeColor") {
          // 第一引数はddのcolor,第二引数はクリック時のcolor,第三引数(オプション)はクリック時の背景色
          const colors = obj[key].split(",");
          targetElm.querySelector(targetClass + "__text").style.color = colors[0];
          addStyles.push(targetClass + "::before {color:" + colors[1] + ";}");
              let i = 1;
          let filterInvert = "filter: invert(1);";
          if (colors[2] !== undefined) {
            i = 2;
            filterInvert = "";
          }
          addStyles.push(
            targetClass +
            "::after {background-color:" +
            colors[i] +
            ";" +
            filterInvert +
            "}"
          );
        } else if (key == "fontSize") {
          const fontSize = obj[key].split(",");
          if (fontSize[1] !== undefined) {
            addStyles.push(
              "@media (max-width: 767px) {" +
              targetClass +
              " {font-size:" +
              fontSize[1] +
              ";}}"
            );
          }
          addStyles.push(targetClass + " {font-size:" + fontSize[0] + ";}");
        } else if (key == "codePosition") {
          targetElm.querySelector(targetClass + "__text").style.bottom = obj[key];
        }
      });
      //スタイルルールの追加
      
      addStyles.forEach((styles) => {
        newStyle.sheet.insertRule(styles, 0);
      });
    }
  
    // クーポンコードのコピー
    document.addEventListener("DOMContentLoaded", function () {
      const targetClassName = ".coupon-code";
      const couponElm = document.querySelectorAll(targetClassName);
      const copiedClass = "is-copied";
      const copyTarget = "dd";
      if (couponElm.length > 0) {
        couponElm.forEach((e) => {
          setupCoupon(e, copyTarget, targetClassName);
          e.addEventListener("click", () => {
            const couponCode = e.querySelector(copyTarget).textContent;
            navigator.clipboard
              .writeText(couponCode)
              .then(() => {
                e.classList.add(copiedClass);
                setTimeout(() => {
                  e.classList.remove(copiedClass);
                }, 3000);
              })
              .catch((err) => {
                console.log("Copy failed", err);
              });
          });
        });
      }
    });
  
  
    
      
;